module.exports = __webpack_public_path__ + "img/header-suche-icon-v2.dffce556.svg";